const SENTENCE_END_MARKERS = '.?!…';
const QUOTATION_GENERIC_MARKERS = `"„'`;
const QUOTATION_CLOSE_MARKERS = '»”’';
const BRACKETS_CLOSE_MARKERS = '\\)\\]\\}>';

export {
    SENTENCE_END_MARKERS,
    QUOTATION_GENERIC_MARKERS,
    QUOTATION_CLOSE_MARKERS,
    BRACKETS_CLOSE_MARKERS,
};
